module.exports = __webpack_public_path__ + "statics/img/jd_B.png";